import { Component, OnInit, AfterViewInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

import { AuthService } from '../auth/auth.service';
import { version } from '../../../package.json';
import { GlobalService } from '../services/global.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit, AfterViewInit {
  model: any = {};
  loading = false;
  returnUrl: string;
  error: string;
  maintenanceWindow:boolean= false;
  maintenanceMessage: string = "We are currently making updates to make your portal better! Please check back later. Thank you.";
  public onlineOffline: boolean = navigator.onLine;

  public waitingOnData: boolean = false;

  public isCompatible: boolean = true;

  public sitePath: string = '';
  public showOrgWelcomeMessage: boolean;
  public isHVAM: boolean;

  public version: string = version;

  constructor(public route: ActivatedRoute, public router: Router, public authService: AuthService, public globalService: GlobalService,) {
    this.sitePath = window.location.hostname;
    this.sitePath = this.sitePath.substring(0, this.sitePath.indexOf('.'));
   
    this.isHVAM = (this.sitePath == 'hvam' || this.sitePath == 'hwh') ? true : false;
    // testing
    // this.isHVAM = true;
    this.globalService.isHVAM = this.isHVAM;
  }

  ngAfterViewInit() {
    if(this.isHVAM){

      //console.log('should not be here');
      let head = document.getElementsByTagName('head')[0];
      let style = document.createElement('link');
      style.rel = 'stylesheet';
      style.href = 'assets/css/hvam/hvam-styling.css';
      head.appendChild(style);
      //console.log('style', head);

    }
  }

  ngOnInit() {  
    //make a call here to check if there is a maintenance window; //not sure if to cache it??
    //need to figure our UTC as well
    var startDate;
    var endDate;
    if(this.maintenanceWindow){
      this.maintenanceMessage = "<b>Maintenance Window:</b> " + startDate + " to " + endDate + "<br/>HVS Portal will be unaccessable between the hours above for updates!";
    }

    //make a check to see if user has proper internet (no internet, slow, fast)
    if(!this.onlineOffline){
      var message = "We are currently seeing that you have either a slow internet connection, or none at all. Please check your wireless or wired connection before attempting to login.";
      if(this.maintenanceWindow){
        this.maintenanceMessage += "<br/>" + message;
      }else{
        this.maintenanceMessage = message;
      }
    }
    

    // reset login status
    this.authService.logout();
    this.showOrgWelcomeMessage = this.sitePath == 'oa' && !localStorage.getItem('org-welcome-message') ? true : false;
    //console.log('ZSS sitepath:', this.sitePath);
    if(this.isHVAM){
      //require('style-loader!assets/css/hvam/hvam-styling.css');
      //document.getElementById('theme22').setAttribute('href', '../../assets/css/hvam/hvam-styling.css');
      //(document.getElementById('theme22') as any) = '../../assets/css/hvam/hvam-styling.css';
    }
    
    //console.log('ZSS sitepath:', this.isHVAM);
    // get return url from route parameters or default to '/'
    this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/home';
    
    // this.isCompatible = /*@cc_on!@*/false || !!document.documentMode;
    this.isCompatible = navigator.userAgent.indexOf("MSIE ") > -1 || navigator.userAgent.indexOf("Trident/") > -1;
  }

  closeWelcomeMessage(e) {
    localStorage.setItem('org-welcome-message', '1');
    this.showOrgWelcomeMessage = false;
  }

  login() {
    this.loading = true;
    this.error = 'Connecting to HVS Portal';
    this.authService.login(this.model.username, this.model.password)
      .subscribe(
        data => {
          if (this.sitePath == 'oa') {
            localStorage.setItem('org-welcome-message', '1')
          }

          this.router.navigate([this.returnUrl]);
          this.loading = false;
        },
        error => {
          this.error = 'Incorrect username or password.';
          this.loading = false;
        });
  }

  handleEnter(e) {
    if (e.keyCode == 13) {
      // console.log('enter');
      this.login();
    }
  }
}
